<template>
    <div id="app">
        <v-app id="inspire" style="background: #F5F8F9">
            <v-parallax dark src="https://cdn.vuetifyjs.com/images/backgrounds/vbanner.jpg" height="250">
                <v-container>
                    <v-layout>
                        <h4 class="subheading font-weight-medium">REPORTS</h4>
                        <v-spacer></v-spacer>
                        <h4 class="subheading font-weight-medium">{{user.displayName}}</h4>
                    </v-layout><br>

                    <v-layout>
                        <v-flex xs8></v-flex>
                        <v-flex xs4 right>
                            <v-menu ref="menuFrom" v-model="menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y full-width min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-layout>
                                        <v-flex xs6>
                                            <v-text-field dark v-model="dateFrom" prepend-icon="event" readonly v-on="on"></v-text-field>
                                        </v-flex>

                                        <v-flex xs6>
                                            <v-text-field dark v-model="dateTo" readonly v-on="on"></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                </template>

                                <v-select :items="ranges" label="Range" v-model="range" solo hide-details @change="menu=false" clearable>
                                </v-select>

                                <v-date-picker v-model="dateFrom" no-title scrollable @change="range=''" :max="new Date().toISOString().substr(0, 10)">
                                </v-date-picker>

                                <v-date-picker v-model="dateTo" no-title scrollable @change="menu=false,range='',fetchTransactions()" :min="dateFrom">
                                </v-date-picker>
                            </v-menu>
                        </v-flex>    
                    </v-layout>

                    <v-layout row wrap>
                        <v-flex xs4>
                            <v-autocomplete v-model="branch" solo label="Branch" :items="branches" persistent-hint hide-no-data clearable leave-absolute hide-details>
                                <template v-slot:append-outer>
                                    <v-slide-x-reverse-transition mode="out-in">
                                    </v-slide-x-reverse-transition>
                                </template>
                            </v-autocomplete>
                        </v-flex>

                        <v-flex xs4>
                            <v-select class="pr-2" hide-details :items="statuses" label="Status" v-model="status" solo clearable>
                            </v-select>
                        </v-flex>  
                    </v-layout>
                </v-container>
            </v-parallax>
            
            <v-layout class="pt-3" row wrap justify-center>
                <v-card width="90%">
                    <v-layout>
                        <v-flex xs8>
                            <v-container>
                                <div class="chart-wrapper">
                                    <chart :options="option"></chart>
                                </div>
                            </v-container>
                            
                        </v-flex>

                        <v-flex xs4>
                            <v-bottom-nav :active.sync="buttonNav" :value="true" color="transparent" class="elevation-0">
                                <v-btn color="primary" flat value="All">
                                    <span class="subheading font-weight-medium">All</span>
                                </v-btn>

                                <v-btn color="primary" flat value="Scheduled">
                                    <span class="subheading font-weight-medium">Scheduled</span>
                                </v-btn>

                                <v-btn color="primary" flat value="Walk-in">
                                    <span class="subheading font-weight-medium">Walk-in</span>
                                </v-btn>
                            </v-bottom-nav>

                            <v-card-text>
                                <h4 class="pt-0 pl-4 pb-0 font-weight-regular"><v-icon small color="black">stop</v-icon>Total</h4>
                                <p class="pt-0 pl-5 display-1 font-weight-bold pl-3">{{transactions.length}}</p>
                                <v-divider class="ml-4" color="black"></v-divider>
                            </v-card-text>
                        </v-flex>
                    </v-layout>
                </v-card>
            </v-layout>

            <v-layout class="pt-5" row wrap justify-center> 
                <v-card width="90%">
                    <v-flex xs6 right>
                        <v-btn v-if="transactions.length>0" flat color="primary" @click="exportDialog=true">
                            <v-icon small class="pr-2">cloud_download</v-icon> Export
                        </v-btn>
                    </v-flex>
                    <v-data-table :headers="headers" :items="transactions" class="elevation-1">
                        <template v-slot:items="props">
                            <td>{{ props.item.transactionId }}</td>
                            <td class="text-xs-left">{{ props.item.customerType }}</td>
                            <td class="text-xs-left">{{ props.item.appointmentDate }}</td>
                            <td class="text-xs-left">{{ props.item.timein }}</td>
                            <td class="text-xs-left">{{ props.item.timeout }}</td>
                            <td class="text-xs-left">{{ props.item.userDetails.fullName }}</td>
                            <td class="text-xs-left"> <div v-for="(service,index) in props.item.initialService" :key="index">{{service.displayName }} </div>
                            <div v-for="(service,index) in props.item.otherService" :key="index">{{service.service }} </div>
                            </td>
                            <td class="text-xs-left">{{ props.item.tag }}</td>
                        </template> 

                        <template v-slot:no-data>
                            <v-alert :value="true" color="grey">
                                No Data Available
                            </v-alert>
                        </template>
                    </v-data-table>
                </v-card>
            </v-layout>
            
            <v-layout>
                <v-container>
                    <v-dialog v-model="exportDialog" max-width="500px">
                        <v-card>
                            <v-parallax dark src="https://cdn.vuetifyjs.com/images/backgrounds/vbanner.jpg" height="80">
                            <v-spacer></v-spacer>
                                <v-container>
                                    <v-layout><br>
                                    <h4 class="title font-weight-medium">Are you sure you want to export this transactions? </h4>
                                    </v-layout>
                                </v-container>
                            </v-parallax>

                            <v-container grid-list>
                                <v-card-text class="subheading font-weight-regular">
                                You are about to download all transactions from selected date range and it will saved as CSV file.
                                </v-card-text>
                                <v-card-text class="subheading font-weight-regular">
                                Do you want to proceed?
                                </v-card-text>

                                <v-card-actions class="justify-center">
                                    <v-btn dark color="red accent-4" @click="exportDialog=false">NO</v-btn>
                                    <v-btn dark color="blue darken-4"  @click="(exportDialog=false),formatData()">YES</v-btn>
                                </v-card-actions>
                            </v-container>
                        </v-card>
                    </v-dialog>

                    <v-dialog v-model="showProgress" persistent width="300">
                        <v-card color="primary">
                            <v-card-text class="subheading white--text"> {{progressMessage}}
                                <v-layout row justify-center>
                                <v-progress-linear :indeterminate="true"
                                    :size="70" :width="5" color="white"
                                ></v-progress-linear>
                                </v-layout>
                            </v-card-text>
                        </v-card>
                    </v-dialog>
        
                    <v-snackbar v-model="snackbar" bottom right :color="snackbarColor" :timeout=3000>
                            {{snackbarMessage}}
                        <v-btn dark small flat @click="snackbar = false">Close</v-btn>
                    </v-snackbar>
                </v-container>
            </v-layout>
        </v-app>                
    </div>
</template>

<script>
import firebase from "firebase";
import firebaseui from "firebaseui";
import "../../node_modules/firebaseui/dist/firebaseui.css";
import { config } from "../firebaseConfig";
import router from '../router';
import { db } from '../main.js'
import { mapGetters, mapActions } from "vuex";
import store from '../stores'
import moment from 'moment'
import _ from 'lodash';
import { sort } from 'semver';

export default {
    data() {
        return {

            option: {
                xAxis: {
                    type: 'category',
                    data: [],
                    boundaryGap: false
                },
                yAxis: {
                    type: 'value',
                    boundaryGap: [0, '30%']
                },
                series: [{
                    data: [],
                    type: 'line',
                    smooth: true,
                    type: 'line',
                    lineStyle: {
                        color: '#008BBB',
                        width: 2
                    },
                    areaStyle: {
                        color: '#61BEDE',
                    }
                }],
            },


            headers: [
                { text: 'Transaction#', align: 'left', sortable: true, value: 'transactionId'},
                { text: 'Type', value: 'customerType',  sortable: false  },
                { text: 'Date', value: 'appointmentDate',  sortable: true  },
                { text: 'Time-in', value: 'timein',  sortable: false  },
                { text: 'Time-out', value: 'timeout',  sortable: false  },
                { text: 'Name', value: 'userDetails.fullName',  sortable: false  },
                { text: 'Services', value: 'initialService',  sortable: false  },
                { text: 'Tag', value: 'tag', sortable: false }
            ],
            buttonNav: 'All',
            dateTo: new moment().utcOffset('+0800').toISOString().substr(0, 10),
            dateFrom: new moment().utcOffset('+0800').toISOString().substr(0, 10),
            menu: false,
            branches: [],
            branch: "",
            snackbar: false,
            snackbarColor: "",
            snackbarMessage: "",
            statuses: ["Show","Cancelled","Rejected"],
            status: "",
            transactions: [],
            formattedTransactions: [],
            range: "",
            ranges: ["1WEEK","1MONTH","MTD","QTD"],
            today: new moment().utcOffset('+0800').toISOString().substr(0, 10),
            weekly: new moment().utcOffset('+0800').subtract(7, 'days').toISOString().substr(0, 10),
            monthly: new moment().utcOffset('+0800').subtract(1, 'months').toISOString().substr(0, 10),
            quarterly: new moment().utcOffset('+0800').subtract(3, 'months').toISOString().substr(0, 10),
            mtd: new moment().utcOffset('+0800').startOf('month').add(1, 'days').toISOString().substr(0, 10),
            inBetween: [],
            showProgress: false,
            progressMessage: "",
            exportDialog: false,
        }
    },


    methods: {
        async fetchBranches() {
            let self = this
            self.branches = []

            await db.collection("Branches"+self.$stage)
            .get().then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                   self.branches.push(`${doc.data().branchCode}_${doc.data().businessUnit}`)
                })
            }).catch(function(error){
                console.log(error)
            })
        },

        fetchTransactions() {
            let self = this
            self.transactions = []
            self.progressMessage ="Loading..."
            self.showProgress = true
            db.collection("ServiceBooking"+self.$stage).get().then(function(querySnapshot){
                querySnapshot.forEach(function(doc) {
                    if (self.buttonNav == "All") {
                        if (doc.data().appointmentDate >= self.dateFrom && doc.data().appointmentDate <= self.dateTo) {
                            if (self.status == "Show") {
                                if (doc.data().tag == "Show") {
                                    if (self.branch == undefined || self.branch == "") {
                                        self.transactions.push(doc.data())
                                    } else {
                                        if (self.branch == `${doc.data().branchCode}_${doc.data().branch}`) {
                                            self.transactions.push(doc.data())
                                        }
                                    }
                                }
                            } else if (self.status == "Cancelled") {
                                if (doc.data().status == "Cancelled") {
                                    if (self.branch == undefined || self.branch == "") {
                                        self.transactions.push(doc.data())
                                    } else {
                                        if (self.branch == `${doc.data().branchCode}_${doc.data().branch}`) {
                                            self.transactions.push(doc.data())
                                        }
                                    }
                                }
                            } else if (self.status == "Rejected") {
                                if (doc.data().status == "Rejected") {
                                    if (self.branch == undefined || self.branch == "") {
                                        self.transactions.push(doc.data())
                                    } else {
                                        if (self.branch == `${doc.data().branchCode}_${doc.data().branch}`) {
                                            self.transactions.push(doc.data())
                                        }
                                    }
                                }
                            } else {
                                if (self.branch == undefined || self.branch == "") {
                                    self.transactions.push(doc.data())
                                } else {
                                    if (self.branch == `${doc.data().branchCode}_${doc.data().branch}`) {
                                        self.transactions.push(doc.data())
                                    }
                                }
                            }  
                        }
                    } else if (self.buttonNav == "Scheduled") {
                        if (doc.data().customerType == "Self-Service") {
                            if (doc.data().appointmentDate >= self.dateFrom && doc.data().appointmentDate <= self.dateTo) {
                                if (self.status == "Show") {
                                    if (doc.data().tag == "Show") {
                                        if (self.branch == undefined || self.branch == "") {
                                            self.transactions.push(doc.data())
                                        } else {
                                            if (self.branch == `${doc.data().branchCode}_${doc.data().branch}`) {
                                                self.transactions.push(doc.data())
                                            }
                                        } 
                                    }
                                } else if (self.status == "Cancelled") {
                                    if (doc.data().status == "Cancelled") {
                                        if (self.branch == undefined || self.branch == "") {
                                            self.transactions.push(doc.data())
                                        } else {
                                            if (self.branch == `${doc.data().branchCode}_${doc.data().branch}`) {
                                                self.transactions.push(doc.data())
                                            }
                                        } 
                                    }
                                } else if (self.status == "Rejected") {
                                    if (doc.data().status == "Rejected") {
                                       if (self.branch == undefined || self.branch == "") {
                                            self.transactions.push(doc.data())
                                        } else {
                                            if (self.branch == `${doc.data().branchCode}_${doc.data().branch}`) {
                                                self.transactions.push(doc.data())
                                            }
                                        } 
                                    }
                                } else {
                                    if (self.branch == undefined || self.branch == "") {
                                        self.transactions.push(doc.data())
                                    } else {
                                        if (self.branch == `${doc.data().branchCode}_${doc.data().branch}`) {
                                            self.transactions.push(doc.data())
                                        }
                                    } 
                                } 
                            }
                        }
                    } else if (self.buttonNav == "Walk-in") {
                        if (doc.data().customerType == "Walk-in") {
                            if (doc.data().appointmentDate >= self.dateFrom && doc.data().appointmentDate <= self.dateTo) {
                                if (self.status == "Show") {
                                    if (doc.data().tag == "Show") {
                                        if (self.branch == undefined || self.branch == "") {
                                            self.transactions.push(doc.data())
                                        } else {
                                            if (self.branch == `${doc.data().branchCode}_${doc.data().branch}`) {
                                                self.transactions.push(doc.data())
                                            }
                                        } 
                                    }
                                } else if (self.status == "Cancelled") {
                                    if (doc.data().status == "Cancelled") {
                                       if (self.branch == undefined || self.branch == "") {
                                            self.transactions.push(doc.data())
                                        } else {
                                            if (self.branch == `${doc.data().branchCode}_${doc.data().branch}`) {
                                                self.transactions.push(doc.data())
                                            }
                                        } 
                                    }
                                } else if (self.status == "Rejected") {
                                    if (doc.data().status == "Rejected") {
                                        if (self.branch == undefined || self.branch == "") {
                                            self.transactions.push(doc.data())
                                        } else {
                                            if (self.branch == `${doc.data().branchCode}_${doc.data().branch}`) {
                                                self.transactions.push(doc.data())
                                            }
                                        } 
                                    }
                                } else {
                                    if (self.branch == undefined || self.branch == "") {
                                        self.transactions.push(doc.data())
                                    } else {
                                        if (self.branch == `${doc.data().branchCode}_${doc.data().branch}`) {
                                            self.transactions.push(doc.data())
                                        }
                                    } 
                                } 
                            }
                        }
                    }
                })
            }).then(function(){
                self.getRange()
                self.showProgress = false
            }).catch(function(error){
                console.log(error)
            })
        },

        getRange() {
            let self = this
            self.inBetween = []
            self.option.xAxis.data = []
            self.option.series[0].data = []
            // let diff = moment(self.dateTo).diff(self.dateFrom, "days")
            // for (let i = 0; i < diff; i++) {
            //     self.inBetween.push(moment(self.dateFrom).add(i, 'days').format('YYYY-MM-DD'))
            // }
            // self.option.xAxis.data = self.inBetween
            // self.getDataFromRange()


            var result = _.chain(self.transactions)
            .groupBy(x => x.appointmentDate)
            .map((value, key) => 
            ({  
                date: key,
                total: value.length,
            })).value();
            setTimeout(() => {
                console.log(result)
                result.forEach(function(doc) {
                    self.option.xAxis.data.push(doc.date)
                    self.option.series[0].data.push(doc.total) 
                })  
            }, 1000);
            

            
            console.log(result)   
            
        },

        getDataFromRange() {
            let self = this
            if (self.inBetween.length == 0){
                self.inBetween.push(new moment().utcOffset('+0800').toISOString().substr(0, 10))
            }
            if (self.buttonNav == "All") {
                self.option.series[0].data = []   
                if (self.transactions.length > 0) {
                    self.transactions.forEach(function(res) {
                        console.log(res.appointmentDate)
                    })

                    self.option.xAxis.data.forEach(function(xAxisResult) {
                      //  console.log(xAxisResult)
                    })
                } 
            }
        },

        formatData() {
            let self = this
            let timein = ""
            let timeout = ""
            let count = 0
            self.formattedTransactions = []

            self.transactions.forEach(function(doc) {
                if (!doc.timein) {
                    timein = ""
                } else {
                    timein = doc.timein
                }

                if (!doc.timeout) {
                    timeout = ""
                } else {
                    timeout = doc.timeout
                }
                var services = []
                for (var i = 0; i < doc.initialService.length; i++) { 
                    services.push(doc.initialService[i].displayName)
                }
                count ++
                self.formattedTransactions.push({
                    "appointment date": doc.appointmentDate,
                    "branch": doc.branch,
                    "branch code": doc.branchCode,
                    "type of customer": doc.customerType,
                    "type of service": doc.jobType,
                    "coupon": "",
                    "services": services,
                    "mechanic": doc.mechanic,
                    "control number": doc.transactionId,
                    "customer name": doc.userDetails.fullName,
                    "appointment time": doc.appointmentTime,
                    "estimate frt": doc.estimateTime,
                    "timein":  timein,
                    "timeout": timeout,
                    "classification": doc.motorcycleDetails.classification,
                    "model": doc.motorcycleDetails.model,
                    "status": doc.status,
                    "tag": doc.tag,
                    "remarks": doc.remarks,
                })
            })

            if (count == self.transactions.length) {
                self.exportRequests()
            }
        },

        exportRequests() {
            let self = this;

            downloadCSV({ filename: "export.csv", data: self.formattedTransactions });

            function convertArrayOfObjectsToCSV(args) {  
                var result, ctr, keys, columnDelimiter, lineDelimiter, data;

                data = args.data || null;
                if (data == null || !data.length) {
                    return null;
                }

                columnDelimiter = args.columnDelimiter || '\t';
                lineDelimiter = args.lineDelimiter || '\n';

                keys = Object.keys(data[0]);

                result = '';
                result += keys.join(columnDelimiter);
                result += lineDelimiter;

                data.forEach(function(item) {
                    ctr = 0;
                    keys.forEach(function(key) {
                        if (ctr > 0) result += columnDelimiter;

                        result += item[key];
                        ctr++;
                    });
                    result += lineDelimiter;
                });

                return result;
            }

            function downloadCSV(args) {  
                var data, filename, link;
                var csv = convertArrayOfObjectsToCSV({
                    data: args.data
                });
                if (csv == null) return;

                filename = args.filename || 'export.csv';

                if (!csv.match(/^data:text\/csv/i)) {
                    csv = 'data:text/csv;charset=utf-8,' + csv;
                }
                data = encodeURI(csv);

                link = document.createElement('a');
                link.setAttribute('href', data);
                link.setAttribute('download', filename);
                link.click();
            }
        }
    },

    mounted() { 
        this.fetchBranches()
        this.fetchTransactions()
    },

    watch: {
        branch(val) {
            this.fetchTransactions()
        },
        
        status(val) {
            this.fetchTransactions()
        },

        buttonNav(val) {
            this.fetchTransactions()
            console.log(val)
        },

        range(val){
            let self = this

            if (val === "1WEEK") {
                self.dateFrom = self.weekly
                self.dateTo = self.today
                self.fetchTransactions()
            } else if (val === "1MONTH") {
                self.dateFrom = self.monthly
                self.dateTo = self.today
                self.fetchTransactions()
            } else if (val === "MTD") {
                self.dateFrom = self.mtd
                self.dateTo = self.today
                self.fetchTransactions()
            } else if (val === "QTD") {
                self.dateFrom = self.quarterly
                self.dateTo = self.today
                self.fetchTransactions()
            } else if (val === undefined){
                self.dateFrom = self.today
                self.dateTo = self.today
                self.fetchTransactions()
            }
        }
    },

    computed : {
        ...mapGetters(["user"]),
    },
}
</script>

<style scoped>
    .v-sheet--offset {
    top: -24px;
    position: relative;
    } 
    .chart-wrapper {
    width: 100%;
    height: 500px;
    }
    .echarts {
    width: 90%;
    height: 100%;
    }
</style>




